import React, {useEffect} from 'react';
import {loadTimelineData} from 'anima-timeline';
import {HashLink as Link} from "react-router-hash-link";
import "../LandingPage/LandingPage.css";
import {header} from "../../data";
import { BrowserRouter as Router,NavLink } from 'react-router-dom';


function App() {
    return <NavBar {...x01LandingPageDesktopData} />;
  }

  export default App;

  function NavBar(props) {
    const {
        headerWithBackground9Props
    } = props;

    return(
        <HeaderWithBackground9 {...headerWithBackground9Props} />
    );
  }

  function White(props) {
    const { src } = props;

    return (
      <div className="lpd-white">
        {/* <img className="lpd-vector" src={src} /> */}
      </div>
    );
  }

  function Group86(props) {
    const { group85, whiteProps } = props;

    return (
      <Link to="/home">
      <div className="lpd-group-86">
        <White src={whiteProps.src} />
        {/* <img className="lpd-group-85" src={group85} /> */}
        <img className="lpd-group-85" src={header.WebuilddHeaderIcon} /> 
      </div>
      </Link>
    );
  }

  function GetAQuoteButton222(props) {
    const { children } = props;

    useEffect(() => {
      loadTimelineData(i2601234964120TimelineData);
    }, []);

    return (
      <div className="lpd-i26012349-64120 lpd-component lpd-component-wrapper not-ready">
        <div className="lpd-master-button-FifxVR">
          <div className="lpd-button-i2601234964-yyNXsM lpd-valign-text-middle">{children}</div>
        </div>
      </div>
    );
  }

  function HeaderWithBackground9(props) {
    const {
      place,
      unselectedI2601234,
      projects,
      unselectedI26012342,
      unselectedI26012343,
      unselectedI26012344,
      unselectedI26012345,
      unselectedI26012346,
      group86Props,
      getAQuoteButton22Props,
    } = props;

    return (
      <div className="lpd-header-with-background">
        <Group86 group85={group86Props.group85} whiteProps={group86Props.whiteProps} />
        <div className="lpd-frame-34">
          <div className="lpd-frame-27">
            <div>
              <div className="lpd-overlap-group1-3">
                {/* <div className="lpd-rectangle-61"></div> */}
                {/* <NavLink> */}
                {/* <div className="lpd-valign lpd-place-2 lpd-valign-text-middle lpd-overpass-bold-shark-14px"></div> */}
                {/* </NavLink> */}
              </div>
            </div>
            <NavLink to="/home">
            <div className="lpd-valign lpd-unselected-i2601234 lpd-valign-text-middle lpd-typography-body-smalltext-14-regular">
            {place}
            </div>
            </NavLink>
            <NavLink to="/about">
            <div className="lpd-valign lpd-unselected-i2601234 lpd-valign-text-middle lpd-typography-body-smalltext-14-regular">
              {unselectedI2601234}
            </div>
            </NavLink>
            <Router forceRefresh={true}>
            <NavLink to="/packagedetails/1/1">
            <div className="lpd-valign lpd-unselected-i2601234 lpd-valign-text-middle lpd-typography-body-smalltext-14-regular">
              PACKAGES
            </div>
            </NavLink>
            </Router>
            {/* <img className="lpd-projects" src={projects} /> */}
            <NavLink to="/project">
            <div className="lpd-valign lpd-projects lpd-unselected-i2601234-0 lpd-valign-text-middle lpd-typography-body-smalltext-14-regular">
            {projects}
            </div>
            </NavLink>
            <NavLink to="/video">
            <div className=" lpd-valign lpd-unselected-i2601234-1 lpd-valign-text-middle lpd-typography-body-smalltext-14-regular">
              {unselectedI26012342}
            </div>
            </NavLink>
            <NavLink to="/insight">
            <div className="lpd-valign lpd-unselected-i2601234-2 lpd-valign-text-middle lpd-typography-body-smalltext-14-regular">
              {unselectedI26012343}
            </div>
            </NavLink>
            <NavLink to="/blog">
            <div className="lpd-valign lpd-unselected-i2601234-3 lpd-valign-text-middle lpd-typography-body-smalltext-14-regular">
              {unselectedI26012344}
            </div>
            </NavLink>
            <NavLink to="/faq">
            <div className="lpd-valign lpd-unselected-i2601234-4 lpd-valign-text-middle lpd-typography-body-smalltext-14-regular">
              {unselectedI26012345}
            </div>
            </NavLink>
            <NavLink to="/contactus">
            <div className="lpd-valign lpd-unselected-i2601234-5 lpd-valign-text-middle lpd-typography-body-smalltext-14-regular">
              {unselectedI26012346}
            </div>
            </NavLink>
          </div>
          <Link  smooth to="/#estimate">
            <GetAQuoteButton222>{getAQuoteButton22Props.children}</GetAQuoteButton222>
          </Link>
        </div>
      </div>
    );
  }

  const getAQuoteButton222Data = {
    children: "GET A QUOTE",
};

const whiteData = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-98@2x.svg",
};

const group86Data = {
    group85: "https://raw.githubusercontent.com/shiddugmail/smk-images/cddd5118ab9b721fb3fcb416b435f6886e587deb/WebuilddLogo.svg", //"https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/group-85-13@2x.svg",
    whiteProps: whiteData,
};

  const headerWithBackground9Data = {
    place: "HOME",
    unselectedI2601234: "ABOUT US",
    projects: "PROJECTS",
    unselectedI26012342: "VIDEOS",
    unselectedI26012343: "INSIGHTS",
    unselectedI26012344: "BLOGS",
    unselectedI26012345: "FAQ’S",
    unselectedI26012346: "CONTACT US",
    group86Props: group86Data,
    getAQuoteButton22Props: getAQuoteButton222Data,
};

const x01LandingPageDesktopData = {
    headerWithBackground9Props: headerWithBackground9Data
};

const i2601234964120TimelineData = [
    {
      initial_state_name: "Property-1=Primary",
      root_element: ".lpd-i26012349-64120",
      states_flow: {
        "Property-1=Primary": {
          listeners: [],
          overrides: {},
        },
        "Property-1=Secondary": {
          listeners: [],
          overrides: {},
        },
        "Property-1=Tertiary": {
          listeners: [],
          overrides: {},
        },
      },
    },
  ];